import React from 'react';
import Reorderable from '@dashboard/components/Reorderable';
import { Accordion } from '@dashboard/components/ui/accordion';
import { useTicketGroupEdit } from '../TicketGroupEditContext';
import useTicketTypeHelpers from '../useTicketTypeHelpers';
import TicketTypeItem from './TicketTypeItem';

export default function TicketTypesList({ ticketTypes, ticketGroupId, usePortal = false }) {
  const { onReorderTicketTypes, editingTicketTypeId } = useTicketGroupEdit();
  const { onEditTicketType, onCancelEditTicketType } = useTicketTypeHelpers();

  const openValue = ticketTypes.some(t => t._id === editingTicketTypeId) ? editingTicketTypeId : '';

  const handleValueChange = value => {
    if (value) {
      onEditTicketType(value);
    } else {
      onCancelEditTicketType();
    }
  };

  return (
    <Accordion
      type="single"
      collapsible
      value={openValue}
      onValueChange={handleValueChange}
      className="border-t"
    >
      <Reorderable.Wrapper>
        <Reorderable
          id="ticketTypes"
          className="flex flex-col"
          items={ticketTypes}
          onReorder={ticketTypes => onReorderTicketTypes(ticketGroupId, ticketTypes)}
          usePortal={usePortal}
          renderItem={({ item: ticketType, dragHandleProps, isDragging }) => (
            <Reorderable.Item isDragging={isDragging}>
              <TicketTypeItem
                ticketType={ticketType}
                ticketGroupId={ticketGroupId}
                dragHandleProps={dragHandleProps}
                isDragging={isDragging}
              />
            </Reorderable.Item>
          )}
        />
      </Reorderable.Wrapper>
    </Accordion>
  );
}
